import { createSubject, deleteSubject, getSubjects, updateSubject } from "../../api/subject";
import { toArray, toObject } from "../../utils/languageContent";
import _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";

const subject = {
    namespaced: true,
    state: {
        subjects: {
            count: 0,
            data: [],
            total: 0,
        },
        selectedSubject: null,
    },
    getters: {
        getUndeleted: (state) => {
            return state.subjects.data.filter((p) => p.isDeleted === false);
        },
        getUserSubjects: (state, getters, rootState) => {
            let userSubs = _.get(rootState.auth, "user.subjects", []);
            if (userSubs.length === 0) return state.subjects.data;
            return state.subjects.data.filter((x) => userSubs.includes(x._id));
        },
    },
    mutations: {
        SET_SUBJECTS: (state, payload) => {
            state.subjects = payload;
        },
        ADD_SUBJECT: (state, payload) => {
            state.subjects.data.push(payload);
            state.subjects.total++;
            state.subjects.count++;
        },
        UPDATE_SUBJECT: (state, payload) => {
            const index = state.subjects.data.findIndex((p) => p._id === payload._id);
            if (index !== -1) {
                state.subjects.data[index] = payload;
            }
        },
        DELETE_SUBJECT: (state, id) => {
            const index = state.subjects.data.findIndex((r) => r._id === id);
            if (index !== -1) {
                state.subjects.data.splice(index, 1);
                state.subjects.total--;
                state.subjects.count--;
            }
        },
        UPDATE_SELECTED_SUBJECT(state, id) {
            state.selectedSubject = id;
        },
    },
    actions: {
        getSubjects({ commit, state }, payload) {
            // State'te her zaman tüm departmanları tutmak için 9999 limit kullanıyoruz
            const fetchLimit = 9999;
            return getSubjects(fetchLimit, 1).then((response) => {
                const total = response.data.total;
                const newData = response.data.data.map((x) => toObject(x));
                
                // Mevcut state'i koru ve yeni departmanları ekle
                const existingData = state.subjects.data;
                const mergedData = [...existingData];
                
                // API'den gelen tüm departmanları kontrol et
                newData.forEach(newItem => {
                    const existingIndex = mergedData.findIndex(item => item._id === newItem._id);
                    if (existingIndex === -1) {
                        // Yeni departman, state'e ekle
                        mergedData.push(newItem);
                    } else {
                        // Mevcut departman, güncelle
                        mergedData[existingIndex] = newItem;
                    }
                });
                
                commit("SET_SUBJECTS", { data: mergedData, count: mergedData.length, total });
                return response;
            });
        },
        setSubjects({ commit }, subjects) {
            const total = subjects.length;
            const count = subjects.length;
            const data = subjects.map((x) => toObject(x));
            commit("SET_SUBJECTS", { data, count, total });
        },
        getSubject({ state }, id) {
            return state.subjects.data.find((p) => p._id === id);
        },
        createSubject({ commit }, payload) {
            return createSubject(toArray(payload)).then((response) => {
                commit("ADD_SUBJECT", toObject(response.data));

                return Promise.resolve(response);
            });
        },
        updateSubject({ commit }, payload) {
            return updateSubject(payload._id, toArray(payload)).then((response) => {
                commit("UPDATE_SUBJECT", toObject(response.data));
            });
        },
        deleteSubject({ commit }, id) {
            return deleteSubject(id).then((response) => {
                commit("DELETE_SUBJECT", id);
            });
        },
        updateSelectedSubject({ commit }, id) {
            commit("UPDATE_SELECTED_SUBJECT", id);
        },
    },
};

export default subject;
